<template>
  <div class="priceManagement-page">
    <div class="all-content-container">
      <div class="screen-all-container">
        <div style="padding: 15px; border: 1px solid #ededed">
          <h3>首页分组参数配置</h3>
          <div class="right-btn">
            <el-button type="primary" @click="handleReturn">返回首页</el-button>
          </div>
        </div>
        <el-tabs v-model="activeName" @tab-click="handleClick" class="el-tab_top">
          <el-tab-pane label="参数类型" name="first">
            <homeParamType></homeParamType>
          </el-tab-pane>
          <el-tab-pane label="分组参数" name="second">
            <homeGroupParam ref="parm"></homeGroupParam>
          </el-tab-pane>
        </el-tabs>
        <div></div>
      </div>
    </div>
  </div>
</template>
<script>
import homeParamType from '../homeParam/homeParamType'
import homeGroupParam from '../homeParam/homeGroupParam'

export default {
  components: {
    homeParamType,
    homeGroupParam
  },
  data() {
    return {
      activeName: 'first'
    }
  },
  created() {
    if (this.$route.query.currentShow) {
      this.activeName = this.$route.query.currentShow
    }
  },
  methods: {
    handleClick() {
      console.log(12);
      this.$refs.parm.getParamList()
    },
    // 返回
    handleReturn() {
      this.$router.push({
        name: 'index2',
        query: {
          greenHouseId: this.$route.query.greenHouseId,
          oneGroupId: this.$route.query.oneGroupId
        }
      })
    }
  }
}
</script>
<style scoped>
@import '../../style/userManagement.scss';
.right-btn {
  margin-top: -30px;
  float: right;
  margin-right: 10px;
}
</style>